"use client";

import React from "react";
import Skeleton from "@/components/ui/Skeleton";

interface StatsCardProps {
  label: string;
  value: string | number;
  percentageChange?: string;
  isPositive?: boolean;
  isLoading?: boolean;
  labelClassName?: string;
  valueClassName?: string;
  percentageClassName?: string;
  className?: string;
}

export default function StatsCard({
  label,
  value,
  percentageChange,
  isPositive = true,
  isLoading = false,
  labelClassName = "",
  valueClassName = "",
  percentageClassName = "",
  className = "",
}: StatsCardProps): React.ReactElement {
  return (
    <div
      className={`py-[20px] w-full px-[30px] border border-foreground/7 bg-foreground/4 ${className}`}
      style={{
        backdropFilter: "blur(61px)",
      }}
    >
      {isLoading ? (
        <>
          {/* label skeleton */}
          <Skeleton className="h-[13px] w-3/5 rounded-none" />
          <div className="flex items-baseline gap-[15px] mt-[10px]">
            {/* value skeleton */}
            <Skeleton className="h-[16px] w-1/3 rounded-none" />
            {/* percentage badge skeleton */}
            <Skeleton className="h-[12px] w-[48px] rounded-none" />
          </div>
        </>
      ) : (
        <>
          <p
            className={`text-foreground text-[13px] font-kode-mono font-normal leading-normal uppercase ${labelClassName}`}
          >
            {label}
          </p>
          <div className="flex items-baseline gap-[15px] mt-[8px] flex-wrap">
            <span
              className={`text-accent-gold text-[16px] font-kode-mono font-medium leading-normal tracking-[-1px] ${valueClassName}`}
            >
              {value}
            </span>
            {percentageChange && (
              <span
                className={`text-[12px] font-kode-mono font-medium leading-[19px] ${
                  isPositive ? "text-accent-green" : "text-accent-red"
                } ${percentageClassName}`}
              >
                {percentageChange}
              </span>
            )}
          </div>
        </>
      )}
    </div>
  );
}

